import { createResource, frappeRequest } from "frappe-ui"
import { computed } from "vue"
import { useSelectedCustomer } from "./useCustomer"
import { useAutoReload } from "./useAutoReload"
import { Resource } from "@/types"

const res = createResource({
  url: "bookings.ui.api.get_cart",
})

export async function refreshCart() {
  res.update({
    params: {
      customer: useSelectedCustomer().value,
    },
  });
  await res.fetch();
}

export function useCart() {
  if (!res.fetched && !res.loading) {
    refreshCart()
    useAutoReload(res)
  }
  return computed(() => res.data)
}

export function useCartLoading() {
  return computed(() => res.loading)
}

export function useCartResource() {
  return res
}

export function makeUpdateCartRes(): Resource {
  return createResource({
    url: "webshop.webshop.shopping_cart.cart.update_cart",
    onSuccess() {
      refreshCart();
    },
  })
}
